// import logo from './logo.svg';
// import "./App.css";
import React from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import SinglePageLayout from "./components/SinglePageLayout";
import { AuthProvider } from "./store/AuthContext";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProjectManager from "./pages/ProjectManager";
import AdminLogin from "./pages/AdminLogin";
import { isLocalEnvironment } from "./utils/environmentUtils";

// Create a modern, vibrant theme for startups
const theme = createTheme({
  palette: {
    primary: {
      main: '#5271FF', // Vibrant blue - modern startup feel
    },
    secondary: {
      main: '#FF914D', // Orange accent - energetic, creative
    },
    background: {
      default: '#FAFBFF', // Light background with a hint of blue
    },
    text: {
      primary: '#2D2D2D', // Dark gray for better readability
    },
  },
  typography: {
    fontFamily: "'Poppins', 'Roboto', sans-serif",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          padding: '10px 20px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
});

// ProtectedRoute component to redirect if not in local environment
function ProtectedRoute({ children }) {
  const isLocalEnv = isLocalEnvironment();
  
  if (!isLocalEnv) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<SinglePageLayout />} />
            <Route path="/admin-login" element={
              <ProtectedRoute>
                <AdminLogin />
              </ProtectedRoute>
            } />
            <Route path="/project-manager" element={
              <ProtectedRoute>
                <ProjectManager />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
